import { render, staticRenderFns } from "./MovieMapping.vue?vue&type=template&id=22cbf51d"
import script from "./MovieMapping.vue?vue&type=script&lang=js"
export * from "./MovieMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22cbf51d')) {
      api.createRecord('22cbf51d', component.options)
    } else {
      api.reload('22cbf51d', component.options)
    }
    module.hot.accept("./MovieMapping.vue?vue&type=template&id=22cbf51d", function () {
      api.rerender('22cbf51d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/MovieMapping.vue"
export default component.exports